module.exports = __webpack_public_path__ + "media/lan/LogoColorIcon96-72b22646.png";